import { Component, Input, OnInit } from "@angular/core";
import * as _ from "underscore";

import { SharedService } from "../../service/api/shared.service";
import { GLOBAL_CONSTANT } from "../../../common/constant/global.constant";
import { UtilityService } from "../../utility.service";

@Component({
  selector: "app-search-visitor",
  templateUrl: "./search-visitor.component.html",
  styleUrls: ["./search-visitor.component.scss"],
})
export class SearchVisitorComponent implements OnInit {
  _data: any;
  _objData: any;
  tableFlag: boolean = false;
  x;
  entrySelectFlag: boolean = false;
  referenceInfo: any;
  genderTypes: any;
  rationCardData: any;
  castData: any;
  subCastData: any;
  editableMode: boolean = false;

  maximunDate = new Date();
  yearRange: any;

  @Input() set data(val) {
    if (val != null || val != undefined) {
      this._data = val;
    }
    if (!_.isEmpty(this._data)) {
      this.editableMode = true;
    }
  }
  get data() {
    return this._data;
  }

  @Input() form;
  @Input() showErrorMsg;
  @Input() showMandatoryMark;
  @Input() showMobileError;

  @Input() componentId;

  constructor(
    private service: SharedService,
    private utilityService: UtilityService
  ) {
    this.rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;

    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.yearRange = this.utilityService.CalYearRange();
  }

  getCast() {
    this.service.getCast().subscribe((res: any) => {
      this.castData = res;

      if (this.editableMode && this._data.cast != undefined) {
        this.castData.filter((cast) => {
          cast.id === this._data.cast["id"] ? (this._data.cast = cast) : "";
          this.getsubcastWithCast(this._data.cast["id"]);
        });
      }
    });
  }

  onChangeCast() {
    let selectedCastId = this._data.cast["id"];
    this.getsubcastWithCast(selectedCastId);
  }

  getsubcastWithCast(id) {
    this.castData.forEach((element) => {
      if (element.id == id) {
        this.subCastData = element.subcast;
        if (this.editableMode === true) {
          this.subCastData.filter((ctype) => {
            ctype.id === this._data.subcast ? (this._data.subcast = ctype) : "";
          });
        }
      }
    });
  }

  SearchReference() {
    this.service.searchVisitor(this.referenceInfo).subscribe(
      (resp) => {
        this._objData = resp;
        if (this._objData != null) {
          if (this._objData.length != 0) {
            this.tableFlag = true;
          }
        }
      },
      (error) => {}
    );
  }

  setReference(_objData) {
    this._data = _objData;

    if (this._data.dob != null || this._data.dob != undefined) {
      this._data.dob !== null
        ? (this._data.dob = new Date(this._data.dob))
        : null;
    }
    this.entrySelectFlag = true;
    this.editableMode = true;
    this.getCast();
    this._data.rationCard = _.find(this.rationCardData, (a) => {
      return a.value === this._data.rationCard;
    });
    // this.onSelect.emit(this._data)
  }

  clearSearch() {
    this.tableFlag = false;
    this.entrySelectFlag = false;
    this._data = {};
  }
  ngOnInit() {
    this.getCast();
  }
}
